
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'LogoFooter'
})
export default class LogoFooter extends Vue {
  @Prop({ type: Boolean, default: false }) isHPTransitionDisabled!: boolean
}
